module.exports = __webpack_public_path__ + "SourceSansPro-ExtraLightItalic.b058aa047243cdf213ff.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-ExtraLightItalic.woff2
// module id = ../../../../../src/assets/customfonts/SourceSansPro-ExtraLightItalic.woff2
// module chunks = styles